"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regex_1 = require("./utils/regex");
const dashRegex = /[ .]/g;
const percentRegex = /%/g;
/**
 * Makes the value safe for use in a class name.
 */
function getSafeValue(value) {
    return value
        .replace(dashRegex, '-')
        .replace(percentRegex, 'prcnt')
        .replace(regex_1.unsafeClassNameCharacters, '');
}
exports.default = getSafeValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXNhZmUtdmFsdWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0LXNhZmUtdmFsdWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx5Q0FBdUQ7QUFFdkQsTUFBTSxTQUFTLEdBQUcsT0FBTyxDQUFBO0FBQ3pCLE1BQU0sWUFBWSxHQUFHLElBQUksQ0FBQTtBQUV6Qjs7R0FFRztBQUNILFNBQXdCLFlBQVksQ0FBQyxLQUFhO0lBQ2hELE9BQU8sS0FBSztTQUNULE9BQU8sQ0FBQyxTQUFTLEVBQUUsR0FBRyxDQUFDO1NBQ3ZCLE9BQU8sQ0FBQyxZQUFZLEVBQUUsT0FBTyxDQUFDO1NBQzlCLE9BQU8sQ0FBQyxpQ0FBeUIsRUFBRSxFQUFFLENBQUMsQ0FBQTtBQUMzQyxDQUFDO0FBTEQsK0JBS0MifQ==